module.exports = __webpack_public_path__ + "static/img/f1.0bad63f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/wind/f1.png
// module id = 7aVn
// module chunks = 0